export const appendRightArrow = (str: string): string => `${str} ›`;
